<template>
    <div>
        <div class="main" v-if="show">
            <div class="loading">
                <p>{{message}}</p>
                {{$t('message.wait')}}
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'waiting',
        props:{
            show:{
                type: Boolean,
                default: true
            },
            message:{
                type: String,
                default: ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
        z-index: 9999;
        .loading{
            box-sizing: border-box;
            width: 300px;
            padding: 20px;
            line-height: 20px;
            background: #fff;
            font-size: 14px;
            text-align: center;
            border-radius: 5px;
            position: relative;
            left: 50%;
            top: 50%;
            margin-left: -150px;
            margin-top: -100px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/waiting.vue